'use strict';

var novicell = novicell || {};

novicell.dataAnchor = novicell.dataAnchor || new function () {

    this.init = function () {
        var getDataAnchors = document.querySelectorAll('.rte a[id]');

        if (!getDataAnchors) {
            return;
        }

        for (var i = 0; i < getDataAnchors.length; i++) {
            let currentAnchor = getDataAnchors[i];

            currentAnchor.setAttribute("style", "position: relative;top: -120px;visibility: hidden;");
        }
    };
}();
